import { Component, OnInit } from '@angular/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { SettingsService } from 'src/app/core/settings/settings.service';

@Component({
  selector: 'app-about-dialog',
  template: '',
  styleUrls: ['./about-dialog.component.scss'],
})
export class AboutDialogComponent implements OnInit {
  private dialogRef: DialogRef;

  constructor(
    private dialogService: DialogService,
    public settings: SettingsService
  ) {}

  ngOnInit(): void {}

  open() {
    this.dialogRef = this.dialogService.open({
      title: 'About CloudRadial Chat',
      content: AboutDialogContentComponent,
      width: 500,
      minWidth: 250,
    });

    // Pass settings service to the dialog content
    const contentInstance = this.dialogRef.content
      .instance as AboutDialogContentComponent;
    contentInstance.settings = this.settings;
  }

  close() {
    this.dialogRef?.close();
  }
}

@Component({
  template: `
    <div class="text-center p-3">
      <div class="mb-4">
        <img
          src="assets/img/newlogo.png"
          alt="CloudRadial Chat"
          style="width: 120px; height: auto;"
        />
      </div>
      <h5 class="mb-3">CloudRadial Chat</h5>
      <p class="mb-1">
        <strong>Version:</strong> {{ settings?.getAppSetting('version') }}
      </p>
      <p class="mb-3 text-muted">
        <small><strong>Build:</strong> {{ settings?.getAppSetting('buildDate') }}</small>
      </p>
      <div class="mt-4">
        <a href="https://support.cloudradial.com" target="_blank" class="mr-3"
          >Support</a
        >
        <span class="text-muted">|</span>
        <a
          href="https://docs.cloudradial.com/docs/terms-of-service"
          target="_blank"
          class="ml-3 mr-3"
          >Terms of Service</a
        >
        <span class="text-muted">|</span>
        <a
          href="https://docs.cloudradial.com/docs/privacy-policy"
          target="_blank"
          class="ml-3"
          >Privacy Policy</a
        >
      </div>
      <div class="mt-3 text-muted">
        <small
          >&copy; {{ settings?.getAppSetting('year') }} CloudRadial. All rights
          reserved.</small
        >
      </div>
    </div>
  `,
})
export class AboutDialogContentComponent {
  public settings: SettingsService;
}
